import {Route, Switch} from 'react-router-dom';
import {useTranslation} from "react-i18next";

import APITable from '../../../../Components/APITable';
import APIForm from '../../../../Components/APIForm';
import {concatURL} from "../../../../Components/utils";

const Tags = ({url}) => {
    const {t, i18n} = useTranslation();
    const TAGS_COLUMNS = [
      {
        name: t('settings.tags.column.name', 'Name'),
        selector: "name",
      },
    ];

    const apiPath='store/tags';

    return <Switch>
        <Route
            exact path={`${url}/create/`}
            render={
                (props) => <>
                    <APIForm
                        apiPath={apiPath}
                        modelId={undefined}
                        method='post'
                        deletionDisabled={true}
                        actionRedirectUrl={`${url}/`}
                    />
                </>
            }
        />
    <Route
        exact path={`${url}/:id/`}
        render={
            props => <>
                <APIForm
                    apiPath={apiPath}
                    modelId={props.match.params.id}
                    method='patch'
                    actionRedirectUrl={`${url}/`}
                />
            </>
        }
    />
    <Route
        exact path={`${url}`}
        render={
            () => <APITable
                apiPath={apiPath}
                columnsConfig={TAGS_COLUMNS}
                tableEmptyMessage={t('settings.tags.list.message.no_data', 'No tags')}
                hasHeader={false}
                hasFilters={true}
                headerButtonCreateUrl={concatURL(url, 'create/')}
                tableCreateButton={true}
            />
        }
    />
</Switch>
};

export default Tags;